var table_viewer_default = {
  "viewMode": "mkOyc",
  "editMode": "D7lVV",
  "container": "CTDxR",
  "cell": "qTL-2"
};
export {
  table_viewer_default as default
};
//# sourceMappingURL=table-viewer-scss.js.map
